<template>
  <div class="content-inner">
    <div class="col-12 list-wrapper">
      <div class="row">
        <div class="col-6">
          <fg-input :placeholder="$t('message.Search')" v-model="search" addon-right-icon="fa fa-search" class="no-border"></fg-input>
        </div>
        <div class="col-6">
          <el-date-picker v-model="dateFilter" type="date" format="dd-MM-yyyy" :placeholder="$t('message.Pick a day')" class="form-group no-border" :editable="false"></el-date-picker>
        </div>
      </div>

      <div v-if="filteredQuestionnaires && filteredQuestionnaires.length">
        <div class="row" style="height: 77vh;">
          <div class="col-12 col-lg-3" style="height: 100%;">
            <!-- List for extra small devices -->
            <div class="row d-block d-md-block d-lg-none" style="height: 100%; overflow:scroll; padding-bottom: 5em;">
              <div class="col-12 questionnaire-list" v-for="questionnaire in filteredQuestionnaires" :key="questionnaire._id">
                <div @click="viewQuestionnaire(questionnaire)">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-2 col-md-1 col-lg-3">
                        <i class="now-ui-icons files_single-copy-04 questionnaire-icon"></i>
                      </div>
                      <div class="col-10 col-md-11 col-lg-9">
                        <p class="card-heading reason">
                          {{ questionnaire.name }}
                        </p>
                        <p class="card-heading">
                          {{ getFormattedDate(questionnaire.updatedAt) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- List for all other bigger deviecs -->
            <div class="row d-none d-md-none d-lg-block" style="height: 100%; overflow-y: scroll;padding-bottom: 5em;">
              <div :class="'col-12 questionnaire-list ' +
                (questionnairesData &&
                  questionnairesData._id == questionnaire._id
                  ? 'selected'
                  : '')
                " v-for="questionnaire in filteredQuestionnaires" :key="questionnaire._id">
                <div @click="selectQuestionnaire(questionnaire)">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-2 col-lg-2">
                        <i class="now-ui-icons files_single-copy-04 questionnaire-icon"></i>
                      </div>
                      <div class="col-10 col-lg-10">
                        <p class="card-heading reason">
                          {{ questionnaire.name }}
                        </p>
                        <p class="card-heading">
                          {{ getFormattedDate(questionnaire.date) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <n-pagination v-if="totalPages" :page-count="totalPages" v-model="pageNumber" class="pagination"></n-pagination>

          </div>

          <div class="col-lg-9 d-none d-lg-block d-xl-block" v-if="questionnairesData" style="height: 100%;overflow: scroll;">
            <card>
              <form-renderer :schema="selectedQuestionnaireJson" :key="selectedQuestionnaireJson.fields[0].name" :read-only="true" model style="margin-top: 2em"></form-renderer>
            </card>
          </div>



        </div>
      </div>

      <div class="row mt-5" v-if="!filteredQuestionnaires.length">
        <div class="col-12 text-center">
          <i class="fa fa-info-circle"></i>
          {{ $t("message.No Questionnaires available") }}
        </div>
      </div>
    </div>


    <n-button type="primary" social icon round size="lg" style="top: auto; inset-inline-end: 10px; bottom: 50px; left: auto; position: fixed" @click.native="answerQuestionnaire()">
      <i class="fa fa-file"></i>
      <i class="fa fa-pencil-alt mt-1" style="font-size: 0.5em; color:var(--color-primary)"></i>
    </n-button>
  </div>
</template>

<script>
import moment from "moment";
import FormRenderer from "src/pages/carenation/components/FormRenderer.vue";

export default {
  name: "questionnaires",

  components: {
    FormRenderer,
  },

  async mounted() {
    try {
      this.getQuestionnaires();
    } catch (e) {
      console.log(e);
    }
  },

  data() {
    return {
      selectedQuestionnaire: null,
      selectedSubQuestionnaire: null,
      search: null,
      dateFilter: null,
      questionnairesData: null,
      questionnaires: [],

      totalPages: 0,
      pageNumber: 1,
      // only get as many questionnaires which can fit in screen
      pageSize: Math.floor(screen.height / 140),
    };
  },

  computed: {
    user() {
      return JSON.parse(localStorage.user);
    },
    selectedQuestionnaireJson() {
      if (this.selectedQuestionnaire) {
        return JSON.parse(this.selectedQuestionnaire);
      }
    },
    filteredQuestionnaires() {
      if (this.questionnaires) {
        return this.questionnaires.filter((questionnaire) => {
          return (
            (!this.search ||
              (questionnaire.name &&
                questionnaire.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1)) &&
            (!this.dateFilter ||
              moment(this.dateFilter).format("MMMM Do YYYY") ==
              moment(questionnaire.created).format("MMMM Do YYYY"))
          );
        });
      }
    },
  },

  methods: {
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    viewQuestionnaire(questionnaire) {
      this.$router.push({ path: "/questionnaireanswers/" + questionnaire._id });
    },
    selectQuestionnaire(questionnaire) {
      this.questionnairesData = questionnaire;
      this.selectedQuestionnaire = this.questionnairesData.answer;
    },
    answerQuestionnaire() {
      this.$router.push({
        path: "/answerquestionnaires/" + this.$route.params.patientId,
      });
    },
    async getQuestionnaires() {
      let response = await this.$store.dispatch("getQuestionnaireAnswers", {
        patientId: this.user.patientId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
      this.questionnaires = response.data;
      this.totalPages = response.totalPages;
      if (this.questionnaires && this.questionnaires.length) {
        this.questionnairesData = this.questionnaires[0];
        this.selectedQuestionnaire = this.questionnairesData.answer;
      }
    },
  },

  watch: {
    pageNumber: function () {
      this.getQuestionnaires();
    },
  },
};
</script>

<style scoped>
.pagination {
  position: absolute;
  bottom: 1em;
  left: 50%;
  transform: translate(-50%);
}

.list-wrapper {
  /* dont need fixed height */
  /* height: 700px; */
  margin-bottom: 1em;
  overflow: scroll;
}

@media (max-height: 892px) {
  .list-wrapper {
    height: 740px;
  }
}

@media (max-height: 812px) {
  .list-wrapper {
    height: 83vh;
  }
}

.questionnaire-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.questionnaire-list:first-child {
  border-top: none;
}

.questionnaire-list.selected {
  background-color: whitesmoke;
}

.questionnaire-icon {
  line-height: 3em;
  color: var(--color-primary);
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}

/deep/ .modal-dialog {
  height: 100%;
}

/deep/ .modal-content {
  height: 97%;
}

/deep/ .has-success .form-control:focus + .input-group-addon {
  color: #555555;
}</style>
